import { requestData } from './async';

/* ****************************************************************************
  Action Creators
******************************************************************************/

export const changePageParamsAction = (subType, field, value, response) => ({
    type: `CHANGE_PAGE_PARAMS_${subType}`,
    field,
    value,
    response
});

export const changePageAction = (subType, pathname, params, response) => ({
    type: `CHANGE_PAGE_${subType}`,
    pathname,
    params,
    response
});

export const updateSectionAction = (subType, pathname, field, value, response) => ({
    type: `UPDATE_SECTION_${subType}`,
    pathname,
    field,
    value,
    response
});

export const openComponent = component => ({
    type: 'OPEN_COMPONENT',
    component
});

export const closeComponent = () => ({
    type: 'CLOSE_COMPONENT'
});

/* ****************************************************************************
  Async Actions
******************************************************************************/

const request = (dispatch, getState, pathname, params, pushState, action, args = []) => {
    dispatch(action('REQUEST', ...args));
    const state = getState();
    return requestData(pathname || state.pathname, params || state.params, pushState)
        .then(result => {
            dispatch(action('SUCCESS', ...args, result));
        })
        .catch(error => {
            dispatch(action('FAILURE', ...args, error));
        });
};

export const changePageParams = (field, value) => (dispatch, getState) =>
    request(dispatch, getState, undefined, undefined, true, changePageParamsAction, [field, value]);

export const changePage = (pathname, params, pushState, noScroll) => (dispatch, getState) =>
    request(dispatch, getState, pathname, params, pushState, changePageAction, [pathname, params]).then(() => {
        if (!noScroll && typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    });

export const updateSection = (pathname, field, value) => (dispatch, getState) => {
    const state = getState();
    const params = {
        ...state.params,
        [field]: value
    };
    return request(dispatch, getState, pathname, params, false, updateSectionAction, [pathname, field, value]);
};



// WEBPACK FOOTER //
// ./src/actions/index.js